module.exports = __webpack_public_path__ + "static/media/conversion_5_blue.86aa0757.png";